import { ERoleType, INpcInfo } from '../chat';
import { EDiscouragedContent, EFollowType, IAuthor, IPrivilegeInfo, IStatisticInfo } from '../feed';
import { IUserBaseInfo } from '../user';

export enum EItemType {
  CHAT = 1,
  CreateNpcGuide = 2,
  Group = 3,
  Story = 4,
  Ad = 5,
  Game = 6,
  TagLanding = 7,
}

export interface IPcLabel {
  label_id: number;
  label_name: string;
}

export interface IGetPcLabelListResp {
  label_list: IPcLabel[];
}

export enum EUserPreferenceType {
  Gender = 1,
  Style = 2,
}

export enum EVipType {
  None = 0, // 没有任何订阅
  TalkiePlusV1 = 1, //目前只有这一种订阅
}

export interface IGetExploreFeedReq {
  page: number;
  is_cold_start?: boolean;
  interest_tag_ids?: number[];
  url_scheme_query?: Record<string, string>;
  appsflyer_params?: string;
  user_preferences?: Record<EUserPreferenceType, string[]>;
  vip?: EVipType;
  feed_label_id?: number;
}

export interface IDebugBaseInfo {
  id: bigint; // i64 can be represented as bigint in TypeScript
  score?: number;
  model_to_score_map?: { [key: string]: number };
  interset_tag?: string;
  tags?: string[];
  rank?: number;
  lora_id?: string;
  discouraged_content?: EDiscouragedContent;
  road_map?: string;
}

export interface IDebugInfo {
  score?: number;
  base_info?: IDebugBaseInfo;
}

export interface IChatData {
  npc_info?: INpcInfo;
  statistic_info?: IStatisticInfo;
  follow_status?: EFollowType;
  privilege_info?: IPrivilegeInfo;
  has_chatted?: boolean;
  timestamp_ms?: number;
  ai_level?: number;

  debug_info?: IDebugInfo;
}

export interface ICreateNpcGuideData {
  title?: string;
  prologue?: string;
  prologue_wav?: string;
  prologue_wav_duration?: number;
  create_button_title?: string;
}

export enum EPrivacy {
  Public = 1,
  Private = 2,
}

enum EGroupModerationStatus {
  DoingModeration = 0,
  VisibleAll = 100,
  VisibleSelf = 200,
  VisibleNone = 300,
  HandsOff = 400,
}

interface IGroupMemberPrologue {
  group_id?: number;
  npc_id?: number;
  prologue?: string;
  prologue_voice_url?: string;
  prologue_voice_duration_ms?: number;
}

interface IGroupMemberRelation {
  group_id?: number;
  relation_from?: number;
  relation_from_role_type?: ERoleType;
  relation_to?: number;
  relation_to_role_type?: ERoleType;
  relation_desc?: string;
}

export interface IGroupTemplatePackInfo {
  group_template_id?: number;
  name?: string;
  desc?: string;
  privacy?: EPrivacy;
  author?: IAuthor;
  moderation_status?: EGroupModerationStatus;
  version?: number;
  group_member_prologues?: IGroupMemberPrologue[];
  group_member_relations?: IGroupMemberRelation[];
  group_member_infos?: IGroupMemberInfo[];
}

export interface IGroupMemberInfo {
  role_type?: ERoleType;
  npc_info?: INpcInfo;
}

export interface IGroupChatData {
  group_template?: IGroupTemplatePackInfo;
  statistic_info?: IStatisticInfo;
  im_group_id?: string;
  current_user_base_info: IUserBaseInfo; // 当前用户的信息
}

export interface IFeedItem {
  item_type: EItemType;
  chat_data?: IChatData;
  guide_data?: ICreateNpcGuideData;
  group_chat_data?: IGroupChatData;
}

export interface IGetExploreFeedResp {
  item_list?: IFeedItem[];
  has_more?: boolean;
}

export interface IGetSimilarNpcListReq {
  npc_id: number;
}

export interface IGetSimilarNpcListResp {
  item_list?: IFeedItem[];
}

export interface IGetTagNpcInfosReq {
  tag_id?: number;
}

export interface PcTagNpcInfo {
  tag_id: number; // 用于后续回传查询
  header: string; // 顶部的文案，对应are you...
  title: string; // 下方的大标题
  emoji: string; // 展示的emoji图标。后续如果要展示文字的话再加字段，避免理解成本
  item_list: IFeedItem[]; // npc列表
}

export interface IGetTagNpcInfosResp {
  tag_npc_info_list: PcTagNpcInfo[];
}

export interface IPostBatchGetNpcProfileReq {
  user_id?: number;
  npc_id_list: number[];
}

export interface IPostBatchGetNpcProfileResp {
  //   npc_profile_map: { [key: number]: IGetNpcProfileResp };
  npc_profile_map: { [key: number]: any };
}

export interface albumInfo {
  album_id: number;
  album_name: string;
  background_color: string;
  cover_url: string;
  thumb_cover_url: string;
}

export interface IPostPlayStoryResp {
  album_list: albumInfo[];
}
